module.exports = __webpack_public_path__ + "img/Phone Icon - charcoal.8aa22993.svg";